module.exports = __webpack_public_path__ + "static/media/blackClover.54ebc630.png";